module.exports = __webpack_public_path__ + "static/media/creators.5ddfbdb5.svg";